import { Exchange, exchangeFromJSON, exchangeToJSON } from '@/types/generated/common/types'

export interface ChartSymbolIdentity {
  exchange: Exchange
  symbol: string
}

const QUALIFIED_SYMBOL_SEPARATOR = ':'

export function qualifyChartSymbol(identity: ChartSymbolIdentity): string {
  return `${getChartExchangeCode(identity.exchange)}${QUALIFIED_SYMBOL_SEPARATOR}${identity.symbol}`
}

export function getChartExchangeCode(exchange: Exchange): string {
  return exchangeToJSON(exchange).replace(/^EXCHANGE_/, '')
}

export function parseQualifiedChartSymbol(value: string): ChartSymbolIdentity | null {
  const separatorIndex = value.indexOf(QUALIFIED_SYMBOL_SEPARATOR)
  if (separatorIndex <= 0 || separatorIndex === value.length - 1) return null

  const exchange = exchangeFromJSON(`EXCHANGE_${value.slice(0, separatorIndex).toUpperCase()}`)
  if (exchange === Exchange.EXCHANGE_UNSPECIFIED || exchange === Exchange.UNRECOGNIZED) return null

  return { exchange, symbol: value.slice(separatorIndex + 1) }
}

export function chartSymbolKey(identity: ChartSymbolIdentity): string {
  return `${identity.exchange}|${identity.symbol}`
}

export function areChartSymbolsEqual(
  left: ChartSymbolIdentity,
  right: ChartSymbolIdentity
): boolean {
  return left.exchange === right.exchange && left.symbol === right.symbol
}
